// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__Kn8cE","container":"styles_container__3zcqL","title":"styles_title__3jxYS","wrapper":"styles_wrapper__2iYF1","answer":"styles_answer__r0Vk4"};